import React from "react";
import Logo from "@/components/Logo";
import { Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#070B19] text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-navy opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 text-white/70 max-w-sm leading-relaxed">
              Energy with Purpose. Strategic Solutions. Sustainable Impact.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-widest text-[#00D084] font-semibold mb-5">
              Navigate
            </div>
            <ul className="space-y-3 text-white/75 text-sm">
              {[
                { id: "about", label: "About" },
                { id: "services", label: "Services" },
                { id: "sectors", label: "Sectors" },
                { id: "approach", label: "Approach" },
                { id: "why", label: "Why TAQAVED" },
                { id: "contact", label: "Contact" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollTo(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="link-underline"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-widest text-[#00D084] font-semibold mb-5">
              Reach us
            </div>
            <ul className="space-y-4 text-white/85 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-white/60" />
                <a
                  href="mailto:info@taqaved.com"
                  className="link-underline"
                  data-testid="footer-email"
                >
                  info@taqaved.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="text-xs text-white/50">
            © {year} TAQAVED. All rights reserved.
          </div>
          <div className="text-xs text-white/40 tracking-widest uppercase">
            Riyadh · KSA · Emerging Markets
          </div>
        </div>
      </div>
    </footer>
  );
}
